@import 'fluid-datepicker.theme.less';

@import '../../styles/mixins/fluid-form-elements.mixin.less';
@import '../../styles/mixins/fluid-transitions.mixin.less';

// ================================================================ //
// -- Theme Definition

:host {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-datepicker {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @datepicker-tokens: @datepicker-tokens-legacy;
      @datepicker();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @datepicker-tokens: @datepicker-tokens-lm;
      @datepicker();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @datepicker-tokens: @datepicker-tokens-corp;
      @datepicker();
    }

    /**
     * LM CORPORATE THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @datepicker-tokens: @datepicker-tokens-portal;
      @datepicker();
    }
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@datepicker: {
  @placeholder: @datepicker-tokens[@placeholder];

  font-family: @font-family;
  line-height: @line-height;

  .form-group {
    .fluid-form-group();

    .input-wrapper {
      position: relative;

      .cancel {
        position: absolute;
        right: 1.25em;
        top: 50%;
        transform: translateY(-50%);
      }

      input {
        .fluid-input(@datepicker-tokens);
        display: grid; // Fixes alignment issues in Chrome/Firefox/Safari

        line-height: 1;
        box-shadow: @datepicker-tokens[box-shadow];
        cursor: text;

        // Hack for overriding default fill color (black) for user agent calendar icon
        &::-webkit-calendar-picker-indicator {
          filter: invert(0.205); // Results in @liberty-gray-dark (#343741)
          cursor: pointer;
        }
      }

      .fluid-pseudo-style(input, @datepicker-tokens);
    }
  }
};


// ================================================================ //
// -- Utility Detached Ruleset(s)

@datepicker-placeholder-text: {
  font-size: @placeholder[font-size];
  font-weight: @placeholder[font-weight];
  text-align: @placeholder[text-align];
  color: @placeholder[text-color];
  padding-right: @datepicker-tokens[text-indent];

  .transition(@property: color, opacity, visibility; @duration: short);
};

@datepicker-placeholder-text-focus: {
  color: transparent;
  opacity: 0;
  visibility: hidden;
};
